import React, { Component } from 'react';
import { intersection, map, isEqual } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import Grid from '../Grid/Grid';
import Carousel from '../Carousel/CarouselLegacyWrapper';
import TitledSection from '../shared/TitledSection';
import { SHOPS, OFFERS, GRID, CAROUSEL } from '../../../../lib/constants';
import { addItemsToDataLayer, dataLayerIdGeneratorNewItem } from '../../../../lib/dataLayerUtils';
import { toSlug } from '../../../../lib/utils';

class LayoutCollectionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };

    this.generateDataLayerIds = this.generateDataLayerIds.bind(this);
    this.updateDataLayerWithNewItems = this.updateDataLayerWithNewItems.bind(this);
  }
  // Analytics: generates IDs for items
  componentWillMount() {
    const {
      items,
      itemType,
    } = this.props;

    this.generateDataLayerIds(items, itemType);
  }

  // Analytics: Update dataLayer with new items
  componentDidMount() {
    const {
      itemType = SHOPS,
    } = this.props;

    this.updateDataLayerWithNewItems(itemType);
  }

  componentWillReceiveProps(nextProps) {
    const {
      items,
      itemType = SHOPS,
    } = nextProps;

    this.generateDataLayerIds(items, itemType);
    this.updateDataLayerWithNewItems(itemType);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Only update if changes to favourites are related to the items in this collection
    const prevGroup = intersection(this.props.favItemIds, map(nextState.items, 'id'));
    const nextGroup = intersection(nextProps.favItemIds, map(nextState.items, 'id'));

    if (!isEqual(prevGroup, nextGroup)) {
      return true;
    }

    // Only update if the items have changed
    if (!isEqual(this.state.items, nextState.items)) {
      return true;
    }

    // Update when parent changes visible items ordering/content.
    if (!isEqual(this.props.items, nextProps.items)) {
      return true;
    }

    // Update when view controller (sorting dropdown) changes selected state.
    if (this.props.renderViewController !== nextProps.renderViewController) {
      return true;
    }

    return false;
  }

  generateDataLayerIds(items, itemType) {
    // Generate ID for dataLayer
    const newItems = items.map((item) => {
      if (item && item.slug) {
        const newItem = dataLayerIdGeneratorNewItem(itemType, item);
        return newItem;
      }
      return item;
    });

    // Save only the necessary data of items to dataLayer
    // (we do not want isFavs and contextContainer)
    this.setState({ items: newItems });
  }

  updateDataLayerWithNewItems(itemType) {
    const items = this.state.items;

    if (window) {
      if (itemType === SHOPS) {
        addItemsToDataLayer(items, SHOPS);
      } else if (itemType === OFFERS) {
        addItemsToDataLayer(items, OFFERS);
      }
    }
  }

  render() {
    const {
      items,
      favItemIds = [],
      Comp,
      viewType,
      itemType = SHOPS,
      sectionTitle,
      showDisplayName,
      buttonText,
      buttonUrl,
      locale,
      removeItemHandler,
      saveItemHandler,
      pageStateModifiers,
      tags,
      slug = '',
      pageContext,
      renderViewController,
    } = this.props;

    const sectionIdentifier = slug || toSlug(sectionTitle);

    // Update items as new userData and context is passed in as props
    // Cannot live in `componentWillMount` because we do not have userData yet
    const itemsToDisplay = this.state.items.map((item, index) => {
      const newItem = Object.assign({}, item);
      newItem.isFavourite = favItemIds.includes(item.id);
      newItem.dataContextContainer = toSlug(sectionTitle);
      newItem.dataIndex = index + 1;
      newItem.pageContext = pageContext || toSlug(sectionTitle);
      if (itemType === SHOPS && sectionIdentifier) {
        newItem.trackingLocation = `page:${sectionIdentifier}-`;
      }
      return newItem;
    });

    const carouselKey = uuidv4();

    let componentToDisplay = null;
    if (viewType === GRID) {
      componentToDisplay = (
        <Grid
          styleDesktop={this.props.styleDesktop}
          styleMobile={this.props.styleMobile}
          items={itemsToDisplay}
          Comp={Comp}
          removeItemHandler={removeItemHandler}
          saveItemHandler={saveItemHandler}
          pageStateModifiers={pageStateModifiers}
          locale={locale} />
      );
    } else if (viewType === CAROUSEL) {
      componentToDisplay = (
        <Carousel
          key={carouselKey}
          items={itemsToDisplay}
          itemType={itemType}
          Comp={Comp}
          removeItemHandler={removeItemHandler}
          saveItemHandler={saveItemHandler}
          pageStateModifiers={pageStateModifiers}
          locale={locale}
          carouselKey={carouselKey} />
      );
    }

    return (
      <TitledSection
        sectionTitle={sectionTitle}
        showDisplayName={showDisplayName}
        viewType={viewType}
        buttonText={buttonText}
        buttonUrl={buttonUrl}
        tags={tags}
        slug={slug}
        locale={locale}
      >
        {renderViewController && renderViewController()}
        {componentToDisplay}
      </TitledSection>
    );
  }
}

export default LayoutCollectionView;
